import * as React from 'react';
import { useEffect } from 'react';
import Box from '@mui/material/Box';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {
  isLoaded,
  retrieveProfile,
  selectProfile,
} from '../features/profile/profileSlice';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { channelId, idToken, userId } from '../utils/liff';
import liff from '@line/liff';
import TopForm from '../components/topForm';
import { useLocation } from 'react-router-dom';
import {
  INFO_APPEND_URL,
  shouldRedirectToInfoAppend,
} from '../utils/csRedirect';

export default function Top() {
  const dispatch = useAppDispatch();
  const profile: any = useAppSelector(selectProfile);
  const loaded = useAppSelector(isLoaded);
  const location = useLocation();

  const shouldRedirect = shouldRedirectToInfoAppend(
    location.pathname,
    location.search,
    'top',
  );

  useEffect(() => {
    if (shouldRedirect) {
      window.location.replace(INFO_APPEND_URL);
      return;
    }

    document.title = '入職書類・社会保険・雇用保険手続き';

    if (!loaded) {
      dispatch(
        retrieveProfile({
          idToken: idToken(),
          channelId: channelId(),
        }),
      );
    }
  }, [loaded, dispatch, shouldRedirect]);

  if (shouldRedirect) {
    return null;
  }

  return (
    <span>
      {!profile ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', paddingTop: 8 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TopForm profile={profile} />
      )}
    </span>
  );
}
